import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Typography, Button } from '@material-ui/core';
import { ACCOUNT_TABLE_COLUMNS } from '../..';
import { useStyles } from './useStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import cx from 'classnames';
import { ACCOUNT_FIELD } from 'src/data/performance';

export const AccountRow = ({
  account,
  onAccountClick,
  isConnected,
  isProcessing,
  hasRunningAccount,
  featureLimitedLabel,
}) => {
  const styles = useStyles();

  return (
    <TableRow
      key={account.id}
      className={styles.root}
      tabIndex={-1}
    >
      {ACCOUNT_TABLE_COLUMNS.slice(0, 2).map((column) => {
        const value = account[column.field];
        return (
          <TableCell
            key={column.field}
            className={styles.cell}
          >
            <Typography className={styles.cellText}>
              {value}
              {featureLimitedLabel && column.field === ACCOUNT_FIELD.name ? (
                <span className={styles.featureLimitedLabel}>{featureLimitedLabel}</span>
              ) : null}
            </Typography>
          </TableCell>
        );
      })}
      <TableCell className={styles.cell}>
        <Button
          onClick={() => onAccountClick(account.id, isConnected)}
          variant="text"
          color="primary"
          className={cx(styles.actionButton, {
            [styles.disconnectButton]: isConnected && !isProcessing,
          })}
          disabled={isProcessing || hasRunningAccount}
          startIcon={
            isProcessing && (
              <CircularProgress
                className={styles.loader}
                size={16}
              />
            )
          }
        >
          {!isConnected && !isProcessing && 'Connect'}
          {isConnected && !isProcessing && 'Disconnect'}
          {isProcessing && 'Processing...'}
        </Button>
      </TableCell>
    </TableRow>
  );
};

AccountRow.propTypes = {
  account: PropTypes.shape(),
  onAccountClick: PropTypes.func,
  isConnected: PropTypes.bool,
  isProcessing: PropTypes.bool,
  hasRunningAccount: PropTypes.bool,
  featureLimitedLabel: PropTypes.string,
};

AccountRow.defaultProps = {
  account: null,
  onAccountClick: null,
  isConnected: false,
  isProcessing: true,
  hasRunningAccount: false,
  featureLimitedLabel: null,
};
